import { Helmet } from 'react-helmet-async';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import Card from '../components/ui/Card';

export default function RefundPolicy() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('refund');

  const handleBack = () => {
    // Check if user came from within the app
    const fromPath = location.state?.from;
    if (fromPath) {
      navigate(fromPath);
    } else {
      // Default to home page
      navigate('/');
    }
  };

  return (
    <>
      <Helmet>
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <div className="container-custom py-12">
          {/* Back Button */}
          <button
            onClick={handleBack}
            className="flex items-center gap-2 text-primary hover:text-primary-dark mb-6 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            {t('back')}
          </button>

          {/* Content */}
          <Card padding="lg" className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t('title')}</h1>

            {t('subtitle') && (
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{t('subtitle')}</h3>
            )}
            <div className="space-y-3 text-gray-700">
              <div className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>{t('policies.noRefund24h')}</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>{t('policies.sickPolicy')}</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>{t('policies.hostCancel')}</p>
              </div>
              <div className="flex gap-3">
                <span className="text-primary font-bold">•</span>
                <p>{t('policies.refundTiming')}</p>
              </div>
            </div>

            {/* Contact Section */}
            <div className="mt-8 p-6 bg-primary-pale rounded-lg">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">{t('contact.title')}</h4>
              <p className="text-gray-700">
                <Trans
                  i18nKey="contact.description"
                  t={t}
                  components={{
                    1: (
                      <a
                        href="mailto:hello@sayyoyo.com"
                        className="text-primary hover:underline font-semibold"
                      />
                    ),
                  }}
                />
              </p>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
